import type { KidStore } from '@stores/kid/interfaces'

export const createInitialState = (): KidStore => ({
  activeKidId: null,
  _hydrated: false,
  disciplinesByKid: {},
})
